var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDdhPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40006152_168675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM8.4375 18.0625L9.40723 19.0322L11.1875 17.2578V21.5H12.5625V17.2578L14.3428 19.0322L15.3125 18.0625L11.875 14.625L8.4375 18.0625ZM4.71777 9.40723L6.49219 11.1875H2.25V12.5625H6.49219L4.71777 14.3428L5.6875 15.3125L9.125 11.875L5.6875 8.4375L4.71777 9.40723ZM14.625 11.875L18.0625 15.3125L19.0322 14.3428L17.2578 12.5625H21.5V11.1875H17.2578L19.0322 9.40723L18.0625 8.4375L14.625 11.875ZM11.875 10C11.1156 10 10.5 10.6156 10.5 11.375C10.5 12.1344 11.1156 12.75 11.875 12.75C12.6344 12.75 13.25 12.1344 13.25 11.375C13.25 10.6156 12.6344 10 11.875 10ZM11.1875 6.49219L9.40723 4.71777L8.4375 5.6875L11.875 9.125L15.3125 5.6875L14.3428 4.71777L12.5625 6.49219V2.25H11.1875V6.49219Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40006152_168675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdhPlatform);
export default __webpack_public_path__ + "static/media/DDH_Platform.11faedff006f5c31efa7080c4ae10551.svg";
export { ForwardRef as ReactComponent };